import { render, staticRenderFns } from "./insight-list.vue?vue&type=template&id=7efcf64d&scoped=true"
import script from "./insight-list.vue?vue&type=script&lang=js"
export * from "./insight-list.vue?vue&type=script&lang=js"
import style0 from "./insight-list.vue?vue&type=style&index=0&id=7efcf64d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcf64d",
  null
  
)

export default component.exports